import { createApp } from 'vue'
import App from './App.vue'

// Vant 4 组件按需引入
import {
  Button,
  Cell,
  CellGroup,
  Field,
  Radio,
  RadioGroup,
  DatePicker,
  Picker,
  Popup,
  Overlay,
  Toast,
  showToast,
  showConfirmDialog,
  Icon,
} from 'vant'
import 'vant/lib/index.css'

const app = createApp(App)

;[
  Button, Cell, CellGroup, Field,
  Radio, RadioGroup,
  DatePicker, Picker, Popup,
  Overlay, Toast, Icon,
].forEach(comp => app.use(comp))

// 挂载全局提示方法
app.config.globalProperties.$toast = showToast
app.config.globalProperties.$dialog = showConfirmDialog

app.mount('#app')
